<div class="row {{customClass}} d-flex layer-header flex-nowrap">
    <div class="flex-auto pl-3">
        <div class="row">
            <ownership [ownership]="ownership" [listIcons]="listIcons" [title]="title" class="result-layer">
            </ownership>
            <div *ngIf="listIcons"
                  class="col-2 text-right">
                <ng-content></ng-content>
                <i *ngIf="listIcons"
                   (click)="setList(false)"
                   class="list-switch list-switch-rows {{!listToggle ? 'active' : ''}} fas fa-list-ul"
                   tooltip="{{'Rows view' | translate}}"
                   placement="left"></i>
                <i *ngIf="listIcons"
                   (click)="setList(true)"
                   class="list-switch list-switch-cards {{listToggle ? 'active' : ''}} fas fa-th-large"
                   tooltip="{{'Cards view' | translate}}"
                   placement="left"></i>
            </div>
        </div>
    </div>
    <div class="flex-auto close-container justify-content-end pr-3">
        <a (click)="close()">
           <i class="far fa-times close-icon"></i>
        </a>
    </div>
</div>